import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { LocationSwitcherComponent } from './location-switcher';
import { SwitcherLocationsListComponent } from './location-switcher/components';
import { FrontendTripleDotsModule } from '@tablesready/frontend-triple-dots';

@NgModule({
  declarations: [
    LocationSwitcherComponent,
    SwitcherLocationsListComponent,
  ],
  imports: [
    FrontendIconsModule,
    CommonModule,
    NgbDropdownModule,
    IonicModule,
    FrontendTripleDotsModule,
  ],
  exports: [LocationSwitcherComponent],
})
export class LocationSwitcherModule { }
